export const UPDATE_FILEROUTETYPE = 'UPDATE_FILEROUTETYPE';
export const ADD_FILEROUTETYPE = 'ADD_FILEROUTETYPE';
export const DELETE_FILEROUTETYPE = 'DELETE_FILEROUTETYPE';
